import React from 'react';
import { useLoaderData } from 'react-router-dom';
import useTitle from '../../hooks/useTittle';
import Reviews from './Reviews/Reviews';

const Food = () => {
    const food = useLoaderData();
    useTitle(food?.name)
    return (
        <div className='bg-base-300 px-5 lg:px-24 py-24'>
            <div className="card w-full bg-base-100 shadow-xl">
                <figure className='h-96'><img className='w-full' src={food.image} alt={food.name} /></figure>
                <div className="card-body">
                    <div className="card-actions justify-between">
                        <h2 className="card-title font-bold text-4xl">{food.name}</h2>
                        <h1 className='text-amber-400 font-bold text-3xl'>Price: {food.price}</h1>
                    </div>
                    <p className='text-[#475569]'>{food.details}</p>
                    <div className="divider text-3xl">Customer Reviews</div>
                    <Reviews food={food} ></Reviews>
                </div>
            </div>
        </div>
    );
};

export default Food;